import Rankings from "@/views/admin/dashboard/Rankings";

export default {
  path: "/admin/dashboard/rankings",
  name: "rankings",
  component: Rankings,
  props: true,
  meta: {
    requiresAuth: true
  }
};
